import btnStyle from '@/components/Shares/Button.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Avatar, Box, Button, Card, Group, Image, NumberFormatter, Paper, Stack, Text } from '@mantine/core';
import { LootBoxesTag } from './LootBoxesTag';
import type { LootBoxesType } from './data';
export const LootBoxesCard: React.FC<LootBoxesType> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  return <Card p={{
    base: 10,
    xl: 16
  }} radius={5} bg="var(--bg-400)">
      <Stack gap={12}>
        <Text w="100%" truncate="end" fz={13} c="var(--text-white)" className={gunterzBold.className}>
          {props.title}
        </Text>
        <Group justify="space-between" gap={10} wrap="nowrap">
          <LootBoxesTag tagType={props.tagType} />

          <Text fz="xs" fw={700}>
            <NumberFormatter value={props.price} decimalScale={2} fixedDecimalScale thousandSeparator="," prefix="$" />
          </Text>
        </Group>

        <Paper h={183} bg="linear-gradient(90deg, #303942 0%, #464F59 100%)">
          <Stack h="100%" gap={10} p={10} justify="center" bg={`radial-gradient(42% 60% at 50% 50%, ${props.boxColor1} 0%, ${props.boxColor2} 100%)`}>
            <Group align="center" justify="center" w="100%" h={132}>
              <Image src={props.boxUrl} w="100%" h="100%" alt="loot-boxes" fit="contain" />
            </Group>

            {props.bonus && <Text w="100%" truncate="end" fz={11} fw={700} tt="uppercase" ta="center">
                {props.bonus}
              </Text>}
          </Stack>
        </Paper>

        <Box>
          <Group justify="space-between" wrap="nowrap">
            <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
              {i18n._('items')}
            </Text>
            <Text fz="xs" fw={700} c="var(--text-green)">
              {props.quantity}
            </Text>
          </Group>

          <Group justify="space-between" mt={10} wrap="nowrap">
            <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
              {i18n._('Creator')}
            </Text>
            <Group gap={6} wrap="nowrap">
              <Avatar src={props.creatorAvatar} size={18} />
              <Text truncate="end" fz="xs" fw={500} c="var(--text-dark)">
                {props.creatorName}
              </Text>
            </Group>
          </Group>
        </Box>

        <Button h={40} classNames={btnStyle}>
          <Text fz={11} fw={700}>
            {i18n._('open for ')}
            <NumberFormatter value={props.openPrice} prefix="$" thousandSeparator="," decimalSeparator="." />
          </Text>
        </Button>
      </Stack>
    </Card>;
};